'use client'

import * as styles from './Menu.css'
import type { ButtonProps } from '@shared/components/Button/Button'
import * as AriakitMenu from '@ariakit/react/menu'
import Button from '@shared/components/Button/Button'
import { Stack } from '@christiankaindl/lyts'

export function Menu({
  children,
  unmountOnHide = true,
  ...props
}: AriakitMenu.MenuProps) {
  return (
    <AriakitMenu.Menu
      unmountOnHide={unmountOnHide}
      portal
      {...props}
      render={<Stack gap='1px' />}
      className={styles.content}
      gutter={6}
    >
      {children}
    </AriakitMenu.Menu>
  )
}

export function MenuButton({
  children,
  ...props
}: AriakitMenu.MenuButtonProps & ButtonProps) {
  return (
    <AriakitMenu.MenuButton
      render={<Button variant={props.variant ?? 'flat'} />}
      className={`${styles.trigger} ${props.className ?? ''}`}
      {...props}
    >
      {children}
    </AriakitMenu.MenuButton>
  )
}

export function MenuProvider(props: AriakitMenu.MenuProviderProps) {
  return <AriakitMenu.MenuProvider {...props} />
}

export default MenuProvider
